import { connect } from 'react-redux';
import { getIsLoggedIn, getCartCount, getCanUserSeeWatch, getCurrentUserHasCore } from '../../publicSession/selectors';
import { getChatUnreadCount } from '../../Chat/redux/selectors';
import { getSiteHeaderState } from '../redux/selectors';
const mapStateToProps = (state)=>({
        hasCoreMembership: getCurrentUserHasCore(state),
        chatCount: getChatUnreadCount(state),
        isLoggedIn: getIsLoggedIn(state),
        cartCount: getCartCount(state),
        canSeeOldWatch: getCanUserSeeWatch(state),
        isShowingDreamUpLink: getSiteHeaderState(state).isShowingDreamUpLink
    });
export default connect(mapStateToProps);

//# sourceMappingURL=SiteHeaderDesktop.container.js.map